import React from 'react';
import ContentLoader from 'react-content-loader';

const StatusLoader = () => (
  <ContentLoader
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    height={20}
    speed={2}
    viewBox="0 0 20 20"
    width={20}>
    <rect height="20" rx="6" ry="6" width="20" x="0" y="0" />
  </ContentLoader>
);

export default StatusLoader;
